import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DATA } from '../data/urunler-data';
import HeaderMenu from './HeaderMenu';
import { Link, useLocation } from 'react-router-dom';
import MenuBack from './MenuBack';
// useTranslation hook'unu import ediyoruz
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const MENU_ITEMS = [
  { name: 'ANASAYFA', link: '/' },
  { name: 'HAKKIMIZDA', link: '/hakkimizda' },
  {
    name: 'SİSTEMLER',
    isDropdown: true,
    data: DATA,
  },
  { name: 'PROJELER', link: '/projeler' },
  // { name: 'BLOG/HABERLER', link: '/blog' },
  { name: 'İLETİŞİM', link: '/iletisim' },
];

const Header2 = ({ toggle, setToggle }) => {
  // Mevcut URL bilgisini almak için useLocation kullanıyoruz
  const location = useLocation();
  // useTranslation hook'u ile çeviri fonksiyonunu alıyoruz
  const { t } = useTranslation();

  

  const currentLanguage = i18n.language; // Get the current language

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    
        
   
   
  };

  const logoSrc = currentLanguage === 'en' ? '/images/en-logo.svg' : '/images/logo.svg';
  // Escape tuşu ile menüyü kapatmak için event listener ekleniyor
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setToggle(false);
      }
    };

    if (toggle) {
      window.addEventListener('keydown', handleKeyDown);
    } else {
      window.removeEventListener('keydown', handleKeyDown);
    }

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle, setToggle]);

  // Logo'ya tıklandığında, eğer ana sayfadaysa menüyü kapatır
  const handleLogoClick = () => {
    if (location.pathname === '/') {
      setToggle(false);
    }
  };

  return (
    <AnimatePresence>
      {toggle && (
        <div data-lenis-prevent className='overscroll-contain'>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            onClick={() => setToggle(false)}
          />

          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.7, ease: "easeInOut" }}
            className="fixed top-0 left-0 w-full h-screen bg-white z-50"
          >
            {/* Kapatma butonu */}
            <div
              onClick={() => setToggle(false)}
              className="h-10 w-10 absolute right-[12%] z-50 top-6 md:top-20 cursor-pointer"
            >
              <div className="relative h-full w-full flex justify-center items-center">
                <div className="h-px w-10 bg-customGray absolute rotate-45"></div>
                <div className="h-px w-10 bg-customGray absolute -rotate-45"></div>
              </div>
            </div>

            <div className="grid grid-cols-14 relative">
              <MenuBack toggle={toggle} />

              <div className="col-start-2 col-span-12 flex flex-col justify-between h-screen overflow-y-auto">
                {/* Logo animasyonu */}
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -30 }}
                  transition={{ duration: 0.7, ease: "easeInOut" }}
                  className="flex justify-between flex-none pt-6 md:pt-20"
                >
                  <Link to={'/'} onClick={handleLogoClick}>
                    <motion.img
                   src={logoSrc}
                      className="w-48 md:w-72 pb-6 md:pb-0 relative z-50"
                      // Logo alt metni çeviri dosyasından çekiliyor
                      alt={t('footer.logoAlt')}
                    />
                  </Link>
                </motion.div>

                {/* Menü animasyonu */}
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.8, delay: 0.2, ease: "easeInOut" }}
                  className="h-full mt-14  !p-0"
                >
                  <HeaderMenu toggle={toggle} setToggle={setToggle} />
                </motion.div>



                {currentLanguage === 'tr'&&
          <motion.div  initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeInOut" }} onClick={() => changeLanguage('en')} className=' mt-10 mb-10 text-16 cursor-pointer hover:scale-105 duration-300'>
              EN
          </motion.div>

}
{currentLanguage === 'en'&&
          <motion.div  initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeInOut" }} onClick={() => changeLanguage('tr')} className='mt-10 mb-10 text-16 cursor-pointer hover:scale-105 duration-300'>
              TR
          </motion.div>
}

                {/* Sosyal medya ikonları animasyonu */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.8, delay: 0.4, ease: "easeInOut" }}
                  className="flex md:flex-col-reverse items-start md:items-start pb-6 md:pb-20 flex-col-reverse md:flex-row"
                >




                  
                  <div className="flex flex-col-reverse md:flex-row text-14 font-medium md:space-x-5">
                    {/* Telif hakkı bilgisi çeviri dosyasından çekiliyor */}
                    <h6>{t('header.copyright')}</h6>
                  </div>




      

                  <div className="flex items-center space-x-5 mb-5 md:mb-5">
                    <motion.a
                      href="https://www.instagram.com/gokdeleniskelekalip/"
                      target="_blank"
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      transition={{ duration: 0.7, delay: 0.5, ease: "easeInOut" }}
                    >
                      <img
                        src="/images/header/i.svg"
                        className="w-6 customHover"
                        alt={t('header.instagramAlt')}
                      />
                    </motion.a>
                    <motion.a
                      href="https://www.facebook.com/gokdeleniskelekalip"
                      target="_blank"
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      transition={{ duration: 0.7, delay: 0.6, ease: "easeInOut" }}
                    >
                      <img
                        src="/images/header/f.svg"
                        className="w-6 customHover"
                        alt={t('header.facebookAlt')}
                      />
                    </motion.a>
                    <motion.a
                      href="https://www.linkedin.com/company/10594998/admin/dashboard/"
                      target="_blank"
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      transition={{ duration: 0.7, delay: 0.7, ease: "easeInOut" }}
                    >
                      <img
                        src="/images/header/li.svg"
                        className="w-6 customHover"
                        alt={t('header.linkedinAlt')}
                      />
                    </motion.a>
                    <motion.a
                      href="https://www.youtube.com/@gokdeleniskelekalp3165"
                      target="_blank"
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      transition={{ duration: 0.7, delay: 0.8, ease: "easeInOut" }}
                    >
                      <img
                        src="/images/header/y.svg"
                        className="w-6 customHover"
                        alt={t('header.youtubeAlt')}
                      />
                    </motion.a>
                  </div>
                  <a href="https://arlametal.com/" target="_blank" className="pb-10 block">
                    <img
                      src="/images/arla2.svg"
                      className="w-28"
                      alt={t('header.arlaAlt')}
                    />
                  </a>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Header2;
